<template>
	<div class="element el-square" :class="{ 'can-change': is_editable }">
		<div class="square-label">{{ label }}</div>
		<div class="square-value">
			<div class="input" :class="{ editable: is_editable }" :contenteditable="is_editable"  @blur="change($event)" >
				<span>
					{{ this.value_text }}
				</span>
				<span style="display:inline" v-if="!is_edit_mode && get_valueText()!='-'">
					{{ suffix }}
				</span>
			</div>
		</div>
		<div  class="square-sub-value" v-if="sub_value">
			<div
				v-if="sub_value.value != ''"
				:class="{ green: sub_value.colored && sub_value.value > 0, red: sub_value.colored && sub_value.value < 0 }"
			>
				<span v-if="sub_value.value && sub_value.value.parent_data">
					<el-textarea :parent_data="sub_value.value.parent_data" :property="sub_value.value.property" inline :editable="is_sub_value_editable" />
				</span>
				<span v-else>{{ sub_value.value }}</span>
				{{ sub_value.suffix }}
			</div>
			<span v-else>-</span>
		</div>
	</div>
</template>

<script>
import { mapGetters } from "vuex";
import ElementMixin from "@/components/study/editor/elements/element.mixin.js";
import elTextarea from "./el-textarea.vue";

export default {
	components: { elTextarea },
	name: "el-square",
	mixins: [ ElementMixin ],
	data: function () {
		return {
			
		};
	},
	props: {
		label: {default: ""},
		placeholder: {default: ""},
		format: { default: "number" },
		suffix: { default: "" },
		sub_value: {},
		is_sub_editable: { type: Boolean, default: false },
	},
	computed: {
		...mapGetters([
			"editor"
		]),
		is_edit_mode: function (){
			const result = this.editor.mode == "editing";
			return result;
		},
		value_text: function () {
			if ( this.value == null || (this.value.trim && this.value.trim().length === 0) || this.value === "") {
				return "-";
			}
			let v = this.value;
			if (this.format == "number" && v != "-") {
				if(isNaN(v)) {
					return "-";
				}

				if (typeof (v) == "string") {
					v = v.replace(",", ".");
				}
				// console.log(v, typeof(v))
				v = parseFloat(v);
				if (v < 100) {
					v = v.toFixed(2);
				} else {
					v = parseInt(v);
				}
				// console.log(v)
			}
			if(this.suffix === "jours"){
				v = Math.round(v);
			}
			return v;
		},
		is_sub_value_editable () {
			return this.sub_value.value && this.sub_value.value.parent_data && this.sub_value.value.property && this.editable;
		}
	},
	mounted () {
		//console.log(this.value_text);
	},
	methods: {
		get_valueText (){
			return this.value_text;
		},
		get_suffix () {
			if (_.isUndefined(this.value) || this.value.trim().length === 0) {
				return " ";
			}
			//console.log(this.suffix)
			return this.suffix;
		},
		change: function (e) {
			if (this.is_editable) this.edit_study(e.target.innerText);
		}
	}
};
</script>

<style lang="stylus" scoped>
@import '../../../../assets/css/app'
@import '../../../../assets/css/page'

.el-square
	display block
	width 100%
	padding 8px
	border-radius radius
	background-color #eee
	text-align center
	font-weight bold
	.square-label
		height 16px
		// margin 0 0 4px 0
		color #666
		line-height (@height - 4px)
	.square-value
		height 24px
		font-size 20px
		line-height @height
	.square-sub-value
		.red
			color red
		.green
			color green
.yanport-kpi
	.square-sub-value
		font-size : 9px !important
</style>